import { ApolloProvider } from "@apollo/client";
import PropTypes from "prop-types";
import type { ReactNode } from "react";
import { Component } from "react";
import { IntlProvider } from "react-intl";
import { Provider as ReduxProvider } from "react-redux";

import { localizedMessages } from "../../locales";
import { client } from "../../utils/kibelaClient2";
import type { store } from "../stores/store";

import type { AppContextValue } from "./AppContext";
import { AppContext } from "./AppContext";

import { CustomEmojiProvider } from "~/client/features/emoji";

interface Props {
  betaFeatures: ReadonlyArray<string>;
  currentUrl: string;
  store: ReturnType<typeof store>;
  locale: keyof typeof localizedMessages;
  children?: ReactNode;
}

export class ContextProvider extends Component<Props> {
  static readonly propTypes = {
    betaFeatures: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    currentUrl: PropTypes.string.isRequired,
  };

  private contextValue(): AppContextValue {
    return {
      betaFeatures: new Set(this.props.betaFeatures),
      currentUrl: this.props.currentUrl,
    };
  }

  render() {
    return (
      <ApolloProvider client={client}>
        <ReduxProvider store={this.props.store}>
          <IntlProvider locale={this.props.locale} messages={localizedMessages[this.props.locale]} textComponent="span">
            <CustomEmojiProvider>
              <AppContext.Provider value={this.contextValue()}>{this.props.children}</AppContext.Provider>
            </CustomEmojiProvider>
          </IntlProvider>
        </ReduxProvider>
      </ApolloProvider>
    );
  }
}
